import React from "react";
import { useEffect } from "react";

const SuccessErrorMessage = (props) => {
  const { showmessage, message, isSuccess, funct } = props;

  let _class = "";
  _class = isSuccess
    ? "alert alert-success alert-dismissible fade show text-center"
    : "alert alert-danger alert-dismissible fade show text-center";

  useEffect(() => {}, [props.showmessage, props.message, props.isSuccess]);

  if (showmessage) {
    return (
      <div className="container pt-4 m-0 col">
        <div className={_class} role="alert">
          {message}
          <button
            type="button"
            onClick={() => {
              {
                funct();
              }
            }}
            className="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    );
  }
  return "";
};
export default SuccessErrorMessage;
